import { ActionTypes } from "./actions";
import produce from "immer";

export const initialState = {
  version: 17,
  currentPage: "HOME",
  tick: 0,
  player: {
    name: "docoo",
    currency: "$",
    xp: 0,
  },
  monies: {
    cash: 0,
    investments: 0,
    bank: 0,
  },
  icecream: {
    rate: 0.15,
    demand: 10,
    xp: 5,
    maxDemand: 20,
    minDemand: 1,
    daily: 0,
    workersHired: 0,
    workers: [
      { name: "Cleaner", income: 1.5, priceToHire: 2, xp: 10 },
      { name: "Packer", income: 5, priceToHire: 10, xp: 20 },
      { name: "Artist", income: 10, priceToHire: 50, xp: 40 },
      { name: "Craftsman", income: 15, priceToHire: 90, xp: 50 },
      { name: "Pro", income: 25, priceToHire: 200, xp: 75 },
      { name: "Ace", income: 40, priceToHire: 400, xp: 100 },
      { name: "Marketer", income: 50, priceToHire: 1000, xp: 150 },
    ],
  },
  lottery: {
    items: [
      { key: 1, price: 1, win: 19, prize: 5, xp: 20 },
      { key: 5, price: 5, win: 24, prize: 25, xp: 50 },
      { key: 10, price: 10, win: 30, prize: 30, xp: 100 },
      { key: 100, price: 100, win: 48, prize: 200, xp: 200 },
      { key: 10000, price: 10000, win: 66, prize: 15000, xp: 500 },
    ],
    moneySpent: 0,
    moneyMade: 0,
  },
  bank: {
    unlocks: 100,
    isUnlocked: false,
    options: [
      {
        name: "Murgun Bank",
        savingInt: 2.5,
        termInt: 4,
        fees: 100,
      },
      { name: "Douche Bank", savingInt: 4, termInt: 8, fees: 5000 },
      { name: "Straight Bank", savingInt: 5, termInt: 8, fees: 40000 },
      { name: "HSBT Bank", savingInt: 3, termInt: 4, fees: 200 },
    ],
    chosenBank: null,
  },
  stocks: {
    unlocks: 100,
    isUnlocked: false,
    invested: 0,
    options: [
      {
        symbol: "GOAL",
        industry: "Computers",
        price: 52.0,
        owned: 0,
        marketCorr: 0.5,
        volality: 0.04,
      },
      {
        symbol: "OIT",
        industry: "Oil",
        price: 39.0,
        owned: 0,
        marketCorr: 0.2,
        volality: 0.1,
      },
      {
        symbol: "APL",
        industry: "Computers",
        price: 19.0,
        owned: 0,
        marketCorr: 0.5,
        volality: 0.08,
      },
      {
        symbol: "X",
        industry: "Phones",
        price: 119.0,
        owned: 0,
        marketCorr: 0.9,
        volality: 0.03,
      },
      {
        symbol: "WALL",
        industry: "Shopping",
        price: 33.0,
        owned: 0,
        marketCorr: 0.2,
        volality: 0.04,
      },
      {
        symbol: "SWAN",
        industry: "Sports",
        price: 74.0,
        owned: 0,
        marketCorr: 0.3,
        volality: 0.05,
      },
      {
        symbol: "Z",
        industry: "Computers ",
        price: 335.0,
        owned: 0,
        marketCorr: 0.5,
        volality: 0.12,
      },
      {
        symbol: "UHA",
        industry: "HealthCare",
        price: 992.0,
        owned: 0,
        marketCorr: 0.02,
        volality: 0.03,
      },
      {
        symbol: "ATT",
        industry: "Phones",
        price: 9.5,
        owned: 0,
        marketCorr: 0.86,
        volality: 0.025,
      },
      {
        symbol: "BER",
        industry: "Sports",
        price: 2.5,
        owned: 0,
        marketCorr: 0.05,
        volality: 0.01,
      },
      {
        symbol: "FT",
        industry: "Software",
        price: 199.3,
        owned: 0,
        marketCorr: 0.25,
        volality: 0.04,
      },
      {
        symbol: "JEB",
        industry: "Jails",
        price: 53.1,
        owned: 0,
        marketCorr: 0.01,
        volality: 0.09,
      },
      {
        symbol: "RVS",
        industry: "Research",
        price: 124.7,
        owned: 0,
        marketCorr: 0.22,
        volality: 0.12,
      },
      {
        symbol: "GME",
        industry: "Cars",
        price: 11.3,
        owned: 0,
        marketCorr: 0.12,
        volality: 0.16,
      },
      {
        symbol: "V",
        industry: "Software",
        price: 229.4,
        owned: 0,
        marketCorr: 0.32,
        volality: 0.07,
      },
    ],
  },
};

export const reducer = (state, action) => {
  switch (action.type) {
    case ActionTypes.CHANGE_PAGE:
      return produce(state, (draft) => {
        draft.currentPage = action.payload.currentPage;
      });
    case ActionTypes.SET_NAME:
      return produce(state, (draft) => {
        draft.player.name = action.payload.name;
      });
    case ActionTypes.DO_ACTION:
      return produce(state, (draft) => {
        draft.monies.cash += draft[action.payload.action].rate;
        draft[action.payload.action].demand -= 1;
        draft.player.xp += draft[action.payload.action].xp;
      });
    case ActionTypes.DO_TICK:
      return produce(state, (draft) => {
        draft.tick += 1;
      });
    case ActionTypes.CHANGE_ACTION_DEMAND:
      return produce(state, (draft) => {
        const actionParams = draft[action.payload.action];
        draft[action.payload.action].demand = Math.min(
          actionParams.demand +
            Math.floor(
              Math.random() * (actionParams.maxDemand - actionParams.demand + 1)
            ),
          actionParams.maxDemand
        );
      });
    case ActionTypes.PLAY_LOTTERY:
      return produce(state, (draft) => {
        const { lottery } = action.payload;
        draft.monies.cash -= lottery.price;
        draft.lottery.moneySpent += lottery.price;
        if (lottery.result) {
          draft.monies.cash += lottery.prize;
          draft.lottery.moneyMade += lottery.prize;
          draft.player.xp += lottery.xp;
        }
      });

    case ActionTypes.HIRE_WORKER:
      return produce(state, (draft) => {
        const { worker } = action.payload;
        draft.icecream.daily += worker.income;
        draft.monies.cash -= worker.priceToHire;
        draft.icecream.workersHired += 1;
      });

    case ActionTypes.ADD_DAILY_INCOME:
      return produce(state, (draft) => {
        const actionName = action.payload.action;
        draft.monies.cash += draft[actionName].daily;
      });
    case ActionTypes.OPEN_BANK_ACCOUNT:
      return produce(state, (draft) => {
        const { bank } = action.payload;
        draft.monies.cash -= bank.fees;
        draft.bank.chosenBank = bank;
        draft.bank.isUnlocked = true;
      });
    case ActionTypes.TRANSFER_MONEY:
      return produce(state, (draft) => {
        const { to, from, amount } = action.payload;
        draft.monies[to] += amount;
        draft.monies[from] -= amount;
      });
    case ActionTypes.BANK_ADD_INTEREST:
      return produce(state, (draft) => {
        const interestRate = state.bank.chosenBank
          ? state.bank.chosenBank.savingInt
          : 0;
        const interest = draft.monies.bank * (interestRate / (100 * 52));
        draft.monies.bank += interest;
      });

    case ActionTypes.BUY_STOCK:
      return produce(state, (draft) => {
        const { stock } = action.payload;
        draft.monies.bank -= stock.price;
        draft.stocks.invested = draft.stocks.invested
          ? draft.stocks.invested + stock.price
          : stock.price;

        const selectedStock = draft.stocks.options.find(
          (option) => option.symbol === stock.symbol
        );
        selectedStock.owned += 1;
      });
    case ActionTypes.UPDATE_STOCK_PRICES:
      return produce(state, (draft) => {
        draft.stocks.options = action.payload.stocks;
      });
    default:
      return state;
  }
};
